// import http from './../../../base/api/public'
// let service = require('@/../config/serviceList')
// let sysConfig = require('@/../config/sysConfig')
// let apiPre = sysConfig.apiPre
// service.res = ''
// export default {
//   getCards (params) {
//     console.log('params:' + JSON.stringify(params))
//     return http.requestPost(apiPre + service.res + '/card/getList', params)
//   }
// }
// 导入基本公共资源
import http from './../../../base/api/public'

let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
export default {

  getPage(params) {
    return http.requestPost(apiPre + service.res + '/scooterRate/getPage', params)
  },

  sava(params) {
    return http.requestPost(apiPre + service.res + '/scooterRate/saveScooterRate', params)
  },

  delete(params) {
    return http.requestGet(apiPre + service.res + '/scooterRate/delete/' + params)
  },

  // 获取枚举
  getEnum() {
    return http.requestGet(apiPre + service.res + '/scooterRate/getEnum');
  },

}



// WEBPACK FOOTER //
// ./src/module/resourceCenter/api/scooterRateApi.js